import { render } from "./SubscriptionPackagesVersion2.vue?vue&type=template&id=0f8eebec"
import script from "./SubscriptionPackagesVersion2.vue?vue&type=script&lang=js"
export * from "./SubscriptionPackagesVersion2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__